// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1___4d1b5c497e7d26c94a3","cls2":"FeedbackModal-cls2___6b4d578e3a7d04d4e32 FeedbackModal-cls1___4d1b5c497e7d26c94a3"};